export const metricsData = [
    { label: 'Total Sales', value: '$150,000' },
    { label: 'Total Ad Spend', value: '$15,000' },
    { label: 'Total Orders', value: '3,000' },
    { label: 'Impressions', value: '100000' },
    { label: 'Impressions', value: '2,000,000' },
    { label: 'Clicks', value: '100,000' },
    { label: 'CTR', value: '5%' },
    { label: 'Conversion Rate', value: '3%' },
    { label: 'Average Order Value', value: '$50' },
    { label: 'ROAS', value: '10x' },
    { label: 'Top Campaign', value: 'Summer Sale' },
    { label: 'Top Product', value: 'Headphones' },
];

export const salesReportData = [
    {
        id: 1,
        period: 'January',
        sales: '$50,000',
        change: '-',
    },
    {
        id: 2,
        period: 'February',
        sales: '$55,000',
        change: '+10%',
    },
    {
        id: 3,
        period: 'March',
        sales: '$60,500',
        change: '+9.1%',
    },
    {
        id: 4,
        period: 'April',
        sales: '$60,500',
        change: '+9.1%',
    },
    {
        id: 5,
        period: 'May',
        sales: '$60,500',
        change: '+9.1%',
    },
    {
        id: 6,
        period: 'June',
        sales: '$60,500',
        change: '+9.1%',
    },
];

export const salesReportColumns = [
    {
        name: 'Period',
        selector: (row) => row.period,
        sortable: true,
    },
    {
        name: 'Total Sales',
        selector: (row) => row.sales,
        sortable: true,
    },
    {
        name: 'Month-over-Month Change',
        selector: (row) => row.change,
        sortable: true,
        grow: 2,
    },
];

export const inventoryReportsData = [
    {
        id: 1,
        productId: '001',
        productName: 'Blue colored headphones',
        stock: 100,
        reorderLevel: 20,
    },
    {
        id: 2,
        productId: '001',
        productName: 'Blue colored headphones',
        stock: 100,
        reorderLevel: 20,
    },
    {
        id: 3,
        productId: '001',
        productName: 'Blue colored headphones',
        stock: 100,
        reorderLevel: 20,
    },
    {
        id: 4,
        productId: '001',
        productName: 'Blue colored headphones',
        stock: 100,
        reorderLevel: 20,
    },
];

export const inventoryReportsColumns = [
    {
        name: 'Product ID',
        selector: (row) => row.productId,
        sortable: true,
    },
    {
        name: 'Product Name',
        selector: (row) => row.productName,
        sortable: true,
    },
    {
        name: 'Current Stock',
        selector: (row) => row.stock,
        sortable: true,
    },
    {
        name: 'Reorder Level',
        selector: (row) => row.reorderLevel,
        sortable: true,
    },
];

export const demographicsData = [
    {
        id: 1,
        ageGroup: '18-24',
        gender: 'Male',
        location: 'Lahore',
        aov: '$50',
    },
    {
        id: 2,
        ageGroup: '25-34',
        gender: 'Female',
        location: 'Karachi',
        aov: '$75',
    },
    {
        id: 3,
        ageGroup: '35-44',
        gender: 'Male',
        location: 'Islamabad',
        aov: '$60',
    },
];

export const demographicsColumns = [
    {
        name: 'Age Group',
        selector: (row) => row.ageGroup,
        sortable: true,
    },
    {
        name: 'Gender',
        selector: (row) => row.gender,
        sortable: true,
    },
    {
        name: 'Location',
        selector: (row) => row.location,
        sortable: true,
    },
    {
        name: 'Average Order Value',
        selector: (row) => row.aov,
        sortable: true,
    },
];

export const marketingData = [
    {
        id: 1,
        campaign: 'Spring Sale',
        startDate: '10/07/2024',
        endDate: '20/07/2024',
        ctr: '5%',
        conversionRate: '2%',
    },
    {
        id: 2,
        campaign: 'Spring Sale',
        startDate: '10/07/2024',
        endDate: '20/07/2024',
        ctr: '5%',
        conversionRate: '2%',
    },
    {
        id: 3,
        campaign: 'Spring Sale',
        startDate: '10/07/2024',
        endDate: '20/07/2024',
        ctr: '5%',
        conversionRate: '2%',
    },
    {
        id: 4,
        campaign: 'Spring Sale',
        startDate: '10/07/2024',
        endDate: '20/07/2024',
        ctr: '5%',
        conversionRate: '2%',
    },
];

export const marketingColumns = [
    {
        name: 'Campaign Name',
        selector: (row) => row.campaign,
        sortable: true,
    },
    {
        name: 'Start Date',
        selector: (row) => row.startDate,
        sortable: true,
    },
    {
        name: 'End Date',
        selector: (row) => row.endDate,
        sortable: true,
    },
    {
        name: 'Click-Through Rate',
        selector: (row) => row.ctr,
        sortable: true,
    },
    {
        name: 'Conversion Rate',
        selector: (row) => row.conversionRate,
        sortable: true,
    },
];

export const financialData = [
    {
        id: 1,
        period: 'Feb 2024',
        revenue: '$200,000',
        cost: '$120,000',
        grossProfit: '$80,000',
        expenses: '$30,000',
        netProfit: '$30,000',
    },
    {
        id: 2,
        period: 'March 2024',
        revenue: '$200,000',
        cost: '$120,000',
        grossProfit: '$80,000',
        expenses: '$30,000',
        netProfit: '$30,000',
    },
    {
        id: 3,
        period: 'April 2024',
        revenue: '$200,000',
        cost: '$120,000',
        grossProfit: '$80,000',
        expenses: '$30,000',
        netProfit: '$30,000',
    },
];

export const financialColumns = [
    {
        name: 'Period',
        selector: (row) => row.period,
        sortable: true,
    },
    {
        name: 'Revenue',
        selector: (row) => row.revenue,
        sortable: true,
    },
    {
        name: 'Cost of Goods Sold',
        selector: (row) => row.cost,
        sortable: true,
        width: '260px',
    },
    {
        name: 'Gross Profit',
        selector: (row) => row.grossProfit,
        sortable: true,
    },
    {
        name: 'Operating Expenses',
        selector: (row) => row.expenses,
        sortable: true,
        width: '280px',
    },
    {
        name: 'Net Profit',
        selector: (row) => row.netProfit,
        sortable: true,
    },
];

export const customStyles = {
    header: {
        style: {
            fontSize: '20px',
            padding: '0',

            div: {
                fontWeight: '600',
            }
        },
    },
    headRow: {
        style: {
            backgroundColor: '#FBBD34',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "40px",
            paddingRight: "40px",
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 40px',
        },
    },
};
